import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import { SERVER_URL } from "../../utils";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = `${SERVER_URL}/api/v1/`;
  },
  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${JwtService.getToken()}`;
    Vue.axios.defaults.headers.common[
      "api_key"
    ] = `1096cc9f-7d74-a4ws-fdfd-da28dbb39ca2`;
  },

  query(resource, params, responseType) {
    return Vue.axios.get(resource, { params, responseType },).catch(error => {
      console.log(error);
      throw new Error(`ApiService ${error}`);
    });
  },


  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  request(request) {
    return Vue.axios.request(request).catch(error => {

      throw new Error(`ApiService ${error}`);
    });
  },
  get(resource, slug = "") {
    return Vue.axios.get(`${resource}${slug == ! "" ? "/" + slug : ''}`).catch(error => {
      // console.log(error);
      throw new Error(`ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params, headers) {
    return Vue.axios.post(`${resource}`, params, { headers });
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;
